import React from 'react';
import { Award, Users, Target } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const About = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-gray-50 to-white dark:from-black dark:via-gray-900 dark:to-black transition-colors duration-200 pt-32 pb-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-gray-900 dark:text-white mb-4">{t('about.title')}</h1>
          <div className="w-24 h-1 bg-green-600 dark:bg-green-500 mx-auto"></div>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20">
          <div className="space-y-6">
            <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">
              {t('about.headline')}
            </h2>
            <p className="text-gray-600 dark:text-gray-400 leading-relaxed text-lg">{t('about.p1')}</p>
            <p className="text-gray-600 dark:text-gray-400 leading-relaxed text-lg">{t('about.p2')}</p>
            <p className="text-gray-600 dark:text-gray-400 leading-relaxed text-lg">{t('about.p3')}</p>
          </div>

          <div className="relative rounded-xl overflow-hidden shadow-2xl">
            <img
              src="https://images.unsplash.com/photo-1531053326607-9d349096d887"
              alt="Fabrikov"
              className="w-full h-full object-cover min-h-[400px]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
          </div>
        </div>

        {/* Values */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl p-8 text-center hover:border-green-500 transition-all duration-300 shadow-lg">
            <div className="w-16 h-16 bg-green-600/10 dark:bg-green-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <Award size={32} className="text-green-600 dark:text-green-400" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">{t('about.qualityTitle')}</h3>
            <p className="text-gray-600 dark:text-gray-400">{t('about.qualityText')}</p>
          </div>

          <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl p-8 text-center hover:border-green-500 transition-all duration-300 shadow-lg">
            <div className="w-16 h-16 bg-green-600/10 dark:bg-green-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <Users size={32} className="text-green-600 dark:text-green-400" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">{t('about.approachTitle')}</h3>
            <p className="text-gray-600 dark:text-gray-400">{t('about.approachText')}</p>
          </div>

          <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl p-8 text-center hover:border-green-500 transition-all duration-300 shadow-lg">
            <div className="w-16 h-16 bg-green-600/10 dark:bg-green-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <Target size={32} className="text-green-600 dark:text-green-400" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">{t('about.customTitle')}</h3>
            <p className="text-gray-600 dark:text-gray-400">{t('about.customText')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
